//
//
//
export default {
  name: 'd2-qrcode'
};